/* @flow */

import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { Form, FormGroup, Row, Col, Button } from 'react-bootstrap'
import { Link } from 'react-router'
import VipSuccess from './VipSuccess'
import FormInput from './FormInput'

const ConvertVipForm = ({
  handleSubmit,
  pristine,
  isPosting,
  postError,
  vipData
}: {
  handleSubmit: Function,
  pristine: boolean,
  isPosting: Function,
  postError: string,
  vipData: {
    pubId: number,
    siteConfigId: number
  }
}) => (
  vipData ?
    <VipSuccess {...vipData} /> :
    <div>
      <Row>
        <Col sm={10} smOffset={1} className="text-center">
          <h1>Convert existing publisher account to VIP with custom URL</h1>
          <h4>Note: this can only be used for publishers keeping shared users.
            Use <Link to="/vip/add">this</Link> form if the publisher wants separate users.</h4>
          <h2 style={{ minHeight: '50px', color: 'red' }}>
            { postError || '' }
          </h2>
        </Col>
      </Row>
      <Form horizontal onSubmit={handleSubmit}>
        <Field
          type="text"
          name="siteName"
          label="Site Name"
          component={FormInput}
          placeholder="vip-example"
          className="form-control"
          required
        />
        <Field
          type="text"
          name="publisherId"
          label="Publisher ID"
          component={FormInput}
          className="form-control"
          required
        />
        <Field
          type="text"
          name="domain"
          label="Domain"
          component={FormInput}
          placeholder="example.submittable.com"
          className="form-control"
          required
        />
        <FormGroup>
          <Col smOffset={4} sm={4}>
            <Button type="submit" disabled={pristine || isPosting}>
              Convert to VIP
            </Button>
          </Col>
        </FormGroup>
      </Form>
    </div>
)

export default reduxForm({
  form: 'convertVip'
})(ConvertVipForm)



// WEBPACK FOOTER //
// ./src/components/ConvertVipForm.js